import React, { useTransition } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const NotFound = () => {
  const { t } = useTranslation()
  return (
    <div className='w-full'> 
      <div className="mx-auto my-24 flex flex-col justify-center items-center w-[70%]">
        <p className='text-6xl'>404 - {t("pageNotFound")}</p>
        <Link className='text-2xl' to={"/"}>{t("goToHome")}</Link>
      </div>
    </div>
  )
}

export default NotFound